
<style type="text/css">
  .fusion-accordian #accordion-1383-2 .panel-title a .fa-fusion-box {
    color: #ffffff;
  }

  .fusion-accordian #accordion-1383-2 .panel-title a .fa-fusion-box:before {
    font-size: 16px;
    width: 16px;
  }

  .fusion-accordian #accordion-1383-2 .panel-title a {
    font-size: 18px;
  }

  .fusion-accordian #accordion-1383-2 .fa-fusion-box {
    background-color: #333333;
    border-color: #333333;
  }

  .fusion-accordian #accordion-1383-2 .panel-title a:hover,
  #accordion-1383-2 .fusion-toggle-boxed-mode:hover .panel-title a {
    color: #ffa626;
  }

  .fusion-accordian #accordion-1383-2 .panel-title .active .fa-fusion-box,
  .fusion-accordian #accordion-1383-2 .panel-title a:hover .fa-fusion-box {
    background-color: #ffa626 !important;
    border-color: #ffa626 !important;
  }
</style>
<div class="accordian fusion-accordian">
  <p><strong>CARTA DI CREDITO</strong></p>
  <div *ngIf="initialLoading" >
      <div class="fusion-sep-clear"></div>
      <div class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto;margin-right: auto;margin-top:30px;"></div>
      <div class="ng-spinner">
        <img src="/wp-content/themes/Avada-Child-Theme/images/spinner_yellow.svg"/>
      </div>
  </div>
  <div class="panel-group" id="accordion-1383-2" role="tablist" *ngIf="paymentMethod != null && paymentMethodInitialized">
    <div class="fusion-panel panel-default fusion-toggle-no-divider" role="tabpanel">
      <div class="panel-heading">
        <h4 class="panel-title toggle"><a aria-expanded="false" aria-selected="false"
            aria-controls="105c7eeee63a4975b" role="tab" data-toggle="collapse"
            data-parent="#accordion-1383-2" data-target="#105c7eeee63a4975b"
            href="#105c7eeee63a4975b"><span class="fusion-toggle-icon-wrapper" aria-hidden="true"><i
                class="fa-fusion-box"></i></span><span class="fusion-toggle-heading">{{creditCardName}}
              termina con {{paymentMethod.creditCardLast4}} - Scad. {{paymentMethod.creditCardExpire}}</span></a></h4>
      </div>
      <div id="105c7eeee63a4975b" class="panel-collapse collapse ">
        <div class="panel-body toggle-content fusion-clearfix">
          <div class="fusion-builder-row fusion-builder-row-inner fusion-row ">
            <div
              class="fusion-layout-column fusion_builder_column fusion_builder_column_1_3 fusion-builder-nested-column-35 fusion-one-third fusion-column-first 1_3"
              style='margin-top: 0px;margin-bottom: 0px;width:33.33%;width:calc(33.33% - ( ( 4% + 4% ) * 0.3333 ) );margin-right:4%;'>
              <div class="fusion-column-wrapper fusion-column-wrapper-35"
                style="padding: 0px 0px 0px 0px;background-position:left top;background-repeat:no-repeat;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;"
                data-bg-url="">

                <div class="fusion-text">
                  <h5>Intestatario carta:<br />
                    {{cardHolder}}</h5>
                </div>


              </div>
            </div>
            <div
              class="fusion-layout-column fusion_builder_column fusion_builder_column_1_3 fusion-builder-nested-column-36 fusion-one-third 1_3"
              style='margin-top: 0px;margin-bottom: 0px;width:33.33%;width:calc(33.33% - ( ( 4% + 4% ) * 0.3333 ) );margin-right:4%;'>
              <div class="fusion-column-wrapper fusion-column-wrapper-36"
                style="padding: 0px 0px 0px 0px;background-position:left top;background-repeat:no-repeat;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;"
                data-bg-url="">



              </div>
            </div>
            <div
              class="fusion-layout-column fusion_builder_column fusion_builder_column_1_3 fusion-builder-nested-column-37 fusion-one-third fusion-column-last 1_3"
              style='margin-top: 0px;margin-bottom: 0px;width:33.33%;width:calc(33.33% - ( ( 4% + 4% ) * 0.3333 ) );'>
              <div class="fusion-column-wrapper fusion-column-wrapper-37"
                style="padding: 0px 0px 0px 0px;background-position:left top;background-repeat:no-repeat;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;"
                data-bg-url="">

                <div class="fusion-button-wrapper fusion-align-block">
                  <style type="text/css">
                    .fusion-button.button-29 {
                      border-radius: 0px;
                    }
                  </style><a (click)="changeCard()"
                    class="fusion-button button-flat fusion-button-default-size button-default button-29 fusion-button-span-yes fusion-button-default-type"
                    target="_self"><span class="fusion-button-text">Modifica</span></a>
                </div>


              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="paymentMethod == null && paymentMethodInitialized">
  <style type="text/css">
    .fusion-accordian #accordion-ng-app-pt .panel-title a .fa-fusion-box {
      color: #ffffff;
    }
  
    .fusion-accordian #accordion-ng-app-pt .panel-title a .fa-fusion-box:before {
      font-size: 16px;
      width: 16px;
    }
  
    .fusion-accordian #accordion-ng-app-pt .panel-title a {
      font-size: 18px;
    }
  
    .fusion-accordian #accordion-ng-app-pt .fa-fusion-box {
      background-color: #333333;
      border-color: #333333;
    }
  
    .fusion-accordian #accordion-ng-app-pt .panel-title a:hover,
    #accordion-ng-app-pt .fusion-toggle-boxed-mode:hover .panel-title a {
      color: #ffa626;
    }
  
    .fusion-accordian #accordion-ng-app-pt .panel-title .active .fa-fusion-box,
    .fusion-accordian #accordion-ng-app-pt .panel-title a:hover .fa-fusion-box {
      background-color: #ffa626 !important;
      border-color: #ffa626 !important;
    }
  </style>
  <div class="accordian fusion-accordian">
    <div class="panel-group" id="accordion-ng-app-pt" role="tablist">
      <div class="fusion-panel panel-default fusion-toggle-no-divider" role="tabpanel">
        <div class="panel-heading">
          <h4 class="panel-title toggle"><a aria-expanded="false" aria-selected="false"
              aria-controls="ng-pt-legend" role="tab" data-toggle="collapse"
              data-parent="#accordion-ng-app-pt" data-target="#ng-pt-legend"
              href="#ng-pt-legend"><span class="fusion-toggle-icon-wrapper" aria-hidden="true"><i
                  class="fa-fusion-box"></i></span><span class="fusion-toggle-heading">LEGENDA</span></a>
          </h4>
        </div>
        <div id="ng-pt-legend" class="panel-collapse collapse ">
          <div class="panel-body toggle-content fusion-clearfix">
            <h5>Tutti i dati obbligatori sono contraddistinti da un asterisco
              &#8220;<strong>*</strong>&#8220;.</h5>
            <h5>Tutti i campi caratterizzati dalla dicitura &#8220;<strong>NP</strong>&#8221; si
              intendono &#8220;Non Pubblici&#8221; ovvero non saranno pubblicati nell&#8217;ambito di
              una Gara.</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="fusion-sep-clear"></div>
  <div class="fusion-separator fusion-full-width-sep sep-none"
    style="margin-left: auto;margin-right: auto;margin-top:40PX;"></div>
  <p><strong>CARTA DI CREDITO (NP)</strong></p>
  <div class="fusion-builder-row fusion-builder-row-inner fusion-row ">
    <div class="fusion-column-wrapper fusion-column-wrapper-40"
      style="padding: 0px 0px 0px 0px;background-position:left top;background-repeat:no-repeat;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;"
      data-bg-url="">
      <ul class="fusion-checklist fusion-checklist-26" style="font-size:16px;line-height:27.2px;">
        <li class="fusion-li-item"><span style="height:27.2px;width:27.2px;margin-right:11.2px;"
          class="icon-wrapper circle-no"><i class="fusion-li-icon fa fa-credit-card"
            style="color:#333333;"></i></span>
          <div class="fusion-li-item-content" style="margin-left:38.4px;">
            N° CARTA*</div>
        </li>
      </ul>
      <div class="fusion-button-wrapper fusion-align-block ng-form">
        <style type="text/css">
          .fusion-button.button-32 .fusion-button-text,
          .fusion-button.button-32 i {
            color: #333333;
          }
  
          .fusion-button.button-32 .fusion-button-icon-divider {
            border-color: #333333;
          }
  
          .fusion-button.button-32:hover .fusion-button-text,
          .fusion-button.button-32:hover i,
          .fusion-button.button-32:focus .fusion-button-text,
          .fusion-button.button-32:focus i,
          .fusion-button.button-32:active .fusion-button-text,
          .fusion-button.button-32:active {
            color: #ffffff;
          }
  
          .fusion-button.button-32:hover .fusion-button-icon-divider,
          .fusion-button.button-32:hover .fusion-button-icon-divider,
          .fusion-button.button-32:active .fusion-button-icon-divider {
            border-color: #ffffff;
          }
  
          .fusion-button.button-32:hover,
          .fusion-button.button-32:focus,
          .fusion-button.button-32:active {
            border-color: #ffffff;
          }
  
          .fusion-button.button-32 {
            border-color: #333333;
            border-radius: 0px;
          }
  
          .fusion-button.button-32 {
            background: #ffffff;
          }
  
          .fusion-button.button-32:hover,
          .button-32:focus,
          .fusion-button.button-32:active {
            background: #ffffff;
          }
        </style>
        <div class="stripe-container">
            <ngx-stripe-card
                [options]="cardOptions"
                [elementsOptions]="elementsOptions">
            </ngx-stripe-card>
<!--             <button type="submit" (click)="createToken()">
                CREATE TOKEN
            </button> -->
         <!--  <stripe-card
            #stripeCard
            (catch)="onStripeError($event)"
            [(invalid)]="invalidError"
            (tokenChange)="setStripeToken($event)"
            (sourceChange)="setStripeSource($event)">
          </stripe-card> -->
        </div>
        <div *ngIf="invalidError" class="alert alert-danger">
        {{ invalidError }}
        </div>
      </div>
    </div>
    <div class="fusion-sep-clear"></div>
    <div class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto;margin-right: auto;margin-top:10px;"></div>
    <div class="fusion-column-wrapper fusion-column-wrapper-40"
      style="padding: 0px 0px 0px 0px;background-position:left top;background-repeat:no-repeat;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;"
      data-bg-url="">
      <ul class="fusion-checklist fusion-checklist-26" style="font-size:16px;line-height:27.2px;">
        <li class="fusion-li-item"><span style="height:27.2px;width:27.2px;margin-right:11.2px;"
            class="icon-wrapper circle-no"><i class="fusion-li-icon fa fa-user-check"
              style="color:#333333;"></i></span>
          <div class="fusion-li-item-content" style="margin-left:38.4px;">
            INTESTATARIO*</div>
        </li>
      </ul>
      <div class="fusion-button-wrapper fusion-align-block">
        <style type="text/css">
          .fusion-button.button-32 .fusion-button-text,
          .fusion-button.button-32 i {
            color: #333333;
          }
  
          .fusion-button.button-32 .fusion-button-icon-divider {
            border-color: #333333;
          }
  
          .fusion-button.button-32:hover .fusion-button-text,
          .fusion-button.button-32:hover i,
          .fusion-button.button-32:focus .fusion-button-text,
          .fusion-button.button-32:focus i,
          .fusion-button.button-32:active .fusion-button-text,
          .fusion-button.button-32:active {
            color: #ffffff;
          }
  
          .fusion-button.button-32:hover .fusion-button-icon-divider,
          .fusion-button.button-32:hover .fusion-button-icon-divider,
          .fusion-button.button-32:active .fusion-button-icon-divider {
            border-color: #ffffff;
          }
  
          .fusion-button.button-32:hover,
          .fusion-button.button-32:focus,
          .fusion-button.button-32:active {
            border-color: #ffffff;
          }
  
          .fusion-button.button-32 {
            border-color: #333333;
            border-radius: 0px;
          }
  
          .fusion-button.button-32 {
            background: #ffffff;
          }
  
          .fusion-button.button-32:hover,
          .button-32:focus,
          .fusion-button.button-32:active {
            background: #ffffff;
          }
        </style>
        <input class="ng-app-input" type="text" [(ngModel)]="cardHolder">
        <div [ngStyle]="{'visibility':cardHorderError === 'no_error' ? 'hidden':'visible'}" class="ng-alert">
          {{cardHorderError}}
        </div>
      </div>
  
    </div>
  </div>
  
  <div class="fusion-sep-clear"></div>
  <div class="fusion-separator fusion-full-width-sep sep-none"
    style="margin-left: auto;margin-right: auto;margin-top:30px;"></div>
  <div class="ng-spinner">
    <img *ngIf="loading" src="/wp-content/themes/Avada-Child-Theme/images/spinner_yellow.svg"/>
  </div>
  <div [ngStyle]="{'visibility':error === 'no_error' ? 'hidden':'visible'}" class="ng-alert">
    {{error}}
  </div>
  <div class="fusion-button-wrapper fusion-alignleft">
    <style type="text/css">
      .fusion-button.button-34 {
        border-radius: 0px;
      }
    </style>
      <a (click)="submitCard()"
      class="fusion-button button-flat button-large button-default button-34 fusion-button-default-span fusion-button-default-type"
      target="_self"><span class="fusion-button-text">Imposta Carta</span></a>
  </div>
</div>

